/**
 * [DSS] Eigenschaften Slider
 * Mobile Swiper - 1 Item sichtbar
 */

import { $, $$, debounce } from '../utils/helpers.js';

class EigenschaftenSlider {
  constructor(containerId) {
    this.containerId = containerId;
    this.slider = $(`.dss-eigenschaften[data-section-id="${containerId}"] .dss-eigenschaften__slider-wrapper`);
    this.track = this.slider?.querySelector('.dss-eigenschaften__grid');
    this.items = this.track ? Array.from(this.track.querySelectorAll('.dss-eigenschaften__item')) : [];
    this.prevBtn = $(`[data-eg-prev="${containerId}"]`);
    this.nextBtn = $(`[data-eg-next="${containerId}"]`);
    this.pagination = $(`[data-eg-pagination="${containerId}"]`);
    this.dots = this.pagination ? Array.from(this.pagination.querySelectorAll('.dss-eigenschaften__pagination-dot')) : [];

    this.currentIndex = 0;
    this.maxIndex = Math.max(0, this.items.length - 1);
    this.isMobile = window.innerWidth < 750;

    if (!this.slider || !this.track || this.items.length <= 1) return;

    this.init();
  }

  init() {
    this.bindEvents();
    this.updateButtons();

    window.addEventListener('resize', debounce(() => this.onResize(), 150));
  }

  onResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth < 750;

    if (this.isMobile && !wasMobile) {
      this.track.style.transform = '';
      this.updatePosition();
      this.updateButtons();
      this.updatePagination();
    } else if (!this.isMobile && wasMobile) {
      this.track.style.transform = '';
      this.currentIndex = 0;
      this.updateButtons();
      this.updatePagination();
    }
  }

  updatePosition() {
    if (!this.isMobile) return;
    const offset = this.currentIndex * 100;
    this.track.style.transform = `translateX(-${offset}%)`;
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prev());
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.next());
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.egIndex, 10);
        this.goToSlide(index);
      });
    });

    let touchStartX = 0;
    let touchEndX = 0;

    this.slider.addEventListener('touchstart', (e) => {
      if (!this.isMobile) return;
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    this.slider.addEventListener('touchend', (e) => {
      if (!this.isMobile) return;
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    }, { passive: true });
  }

  handleSwipe(startX, endX) {
    const threshold = 50;
    const diff = startX - endX;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.next();
      } else {
        this.prev();
      }
    }
  }

  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.updatePosition();
      this.updateButtons();
      this.updatePagination();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updatePosition();
      this.updateButtons();
      this.updatePagination();
    }
  }

  goToSlide(index) {
    if (index >= 0 && index <= this.maxIndex) {
      this.currentIndex = index;
      this.updatePosition();
      this.updateButtons();
      this.updatePagination();
    }
  }

  updateButtons() {
    if (!this.isMobile) {
      if (this.prevBtn) this.prevBtn.disabled = true;
      if (this.nextBtn) this.nextBtn.disabled = true;
      return;
    }

    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
    }

    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    }
  }

  updatePagination() {
    if (!this.dots.length) return;

    this.dots.forEach((dot, index) => {
      if (index === this.currentIndex) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }
}

function initEigenschaftenSliders() {
  const sections = $$('.dss-eigenschaften[data-section-id]');

  sections.forEach(section => {
    const id = section.dataset.sectionId;
    if (id) {
      new EigenschaftenSlider(id);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEigenschaftenSliders);
} else {
  initEigenschaftenSliders();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.detail?.sectionId) {
    const section = document.querySelector(`.dss-eigenschaften[data-section-id="${event.detail.sectionId}"]`);
    if (section) {
      new EigenschaftenSlider(event.detail.sectionId);
    }
  }
});

export { EigenschaftenSlider, initEigenschaftenSliders };
